module.exports = __webpack_public_path__ + "static/lulu-loyal-hollyphant-fc5ec52c5b0dc24ed3e6658a4aa58f6c.jpg";